<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="560px">
    <v-card>
      <v-card-title class="headline">
        {{ $t("employee.assignRoleTitle") }}
        <span v-if="item && item.name" class="grey--text text--darken-1 ml-2">
          – {{ item.name }}
        </span>
      </v-card-title>

      <v-card-text>
        <!-- Pick an existing role to assign -->
        <div class="subtitle-1 mb-2">{{ $t("employee.selectRoleToAdd") }}</div>

        <div v-if="availableRoles.length" class="d-flex flex-wrap">
          <v-chip
            v-for="role in availableRoles"
            :key="role.key"
            class="ma-1"
            outlined
            @click="onSelect(role)"
          >
            <v-icon left small>{{ role.icon }}</v-icon>
            {{ role.label }}
          </v-chip>
        </div>
        <div v-else class="caption grey--text mb-2">
          {{ $t("employee.noMoreRoles") }}
        </div>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="grey" outlined @click="close">
          {{ $t("general.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "addRoleDialog",
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) },
    assignedKeys: { type: Array, default: () => [] },
    builtInRoles: { type: Array, default: () => [] },
  },
  computed: {
    customRoleDefs() {
      return this.$store.getters.employeeRoleDefinitions || [];
    },
    customRoleDescriptors() {
      return this.customRoleDefs.map((d) => ({
        key: d._id,
        icon: d.icon || "mdi-account-star",
        label: d.name,
        requireDate: false,
        requireFile: false,
        showDate: true,
        isBuiltIn: false,
      }));
    },
    // Roles not yet assigned to this employee.
    availableRoles() {
      const assigned = this.assignedKeys || [];
      return [...this.builtInRoles, ...this.customRoleDescriptors].filter(
        (r) => !assigned.includes(r.key),
      );
    },
  },
  methods: {
    onSelect(role) {
      this.$emit("select", role);
    },
    close() {
      this.$emit("input", false);
    },
  },
};
</script>
